// import React, { useEffect, useState, useCallback } from "react";
// import "../assets/SalaryDisbursement.css";
// import axios from "axios";
// import { toast } from "react-toastify";


// import * as XLSX from "xlsx";
// import { saveAs } from "file-saver";
// import jsPDF from "jspdf";
// import autoTable from "jspdf-autotable";


// const ITEMS_PER_PAGE_OPTIONS = [10, 25, 50, 100];
// const API_URL = "https://narrowitsolution.in/api";

// const SalaryDisbursement = () => {
//   const [salaries, setSalaries] = useState([]);
//   const [branchs, setBranchs] = useState([]);
//   const [employees, setEmployees] = useState([]);

//   const [month, setMonth] = useState("");
//   const [appliedMonth, setAppliedMonth] = useState("");

//   const [selectedBranch, setSelectedBranch] = useState(null);
//   const [selectedEmployee, setSelectedEmployee] = useState(null);

//   const [currentPage, setCurrentPage] = useState(1);
//   const [rowsPerPage, setRowsPerPage] = useState(10);
//   const [totalPages, setTotalPages] = useState(1);
//   const [totalRecords, setTotalRecords] = useState(0);
//   const [modalOpen, setModalOpen] = useState(false);
//   const [selectedSalaryId,setSelectedSalaryId]=useState();

//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState("");
//   const superAdminId = localStorage.getItem("adminuserId");

   

//   const DisburseSalary = async (e) => {
//     // console.log("payloads are", salaryId, month, year);
//     e.preventDefault();
//     try {
//       const response = await axios.post(
//         "https://narrowitsolution.in/api/disubursed-salary/employe",
//         {
//           salaryId: selectedSalaryId,
//           paymentMode: formData.paymentMode,
//           transactionRef: formData.transactionRef
//         }
//       );
  
//       toast.success("Salary Disbursed successfully!");
//       setModalOpen(false);
//       fetchSalary();
//       return response.data;
//     } catch (error) {
//       const msg =
//         error?.response?.data?.message || "Something went wrong while Disbursing salary";
  
//        toast.error(msg); 
//       //  toast.error(
//           //    error.response?.data?.message || "Something went wrong while calculating salary"
//           //  );
//       console.error("Error calculating salary:", msg);
//       return null; // prevent crash
//     }
//   };
  

//   const [formData, setFormData] = useState({
//       paymentMode:"",
//       transactionRef: "",
//     });

//   const handleChange = (e) => {
//     setFormData({ ...formData, [e.target.name]: e.target.value });
//   };
//   /* ================= FETCH BRANCH ================= */
//   useEffect(() => {
//     const fetchBranch = async () => {
//       try {
//         const res = await axios.get(`${API_URL}/get-branch`, {
//           params: {
//             SuperAdminId: localStorage.getItem("adminuserId"),
//             limit: "all",
//           },
//         });
//         setBranchs(res?.data?.branches || []);
//       } catch (err) {
//         console.error(err);
//       }
//     };
//     fetchBranch();
//   }, []);

//   /* ================= FETCH EMPLOYEES ================= */
//   useEffect(() => {
//     if (!selectedBranch) {
//       setEmployees([]);
//       setSelectedEmployee(null);
//       return;
//     }

//     const fetchEmployees = async () => {
//       try {
//         const res = await axios.get(`${API_URL}/get-employ`, {
//           params: {
//             superAdminId: localStorage.getItem("adminuserId"),
//             branchId: selectedBranch.id,
//             limit: 50,
//           },
//         });
//         setEmployees(res?.data?.data || []);
//       } catch (err) {
//         console.error(err);
//       }
//     };

//     fetchEmployees();
//   }, [selectedBranch]);

//   /* ================= FETCH SALARY ================= */
//   const fetchSalary = useCallback(
//     async (isFiltered = false) => {
//       try {
//         setLoading(true);
//         setError("");

//         const token = localStorage.getItem("authToken");
//         const superAdminId = localStorage.getItem("adminuserId");

//         const res = await axios.get(
//           `${API_URL}/get-all-salery-disbursed/get-all`,
//           {
//             params: {
//               superAdminId,
//               currentPage,
//               pageSize: rowsPerPage,
//               employee_id: isFiltered ? selectedEmployee?.id : undefined,
//               month: isFiltered ? appliedMonth : undefined,
//             },
//             headers: {
//               Authorization: `Bearer ${token}`,
//             },
//           }
//         );

//         setSalaries(res?.data?.data || []);
//         setTotalPages(res?.data?.totalPages || 1);
//         setTotalRecords(res?.data?.totalRecords || 0);
//       } catch (err) {
//         setError(err?.response?.data?.message || "Failed to fetch salaries");
//       } finally {
//         setLoading(false);
//       }
//     },
//     [currentPage, rowsPerPage, selectedEmployee, appliedMonth]
//   );

//   /* ================= DEFAULT LOAD ================= */
//   useEffect(() => {
//     fetchSalary(false);
//   }, [fetchSalary]);

//   /* ================= FILTER SUBMIT ================= */
//   const handleSubmit = (e) => {
//     e.preventDefault();

//     if (!selectedBranch || !selectedEmployee || !month) {
//       toast.error("Please select branch, employee and month");
//       return;
//     }

//     setAppliedMonth(month);
//     setCurrentPage(1);

//     fetchSalary(true);
//   };

//   /* ================= PER PAGE ================= */
//   const handleItemsPerPageChange = (e) => {
//     setRowsPerPage(Number(e.target.value));
//     setCurrentPage(1);
//   };


// const downloadExcel = () => {
//   if (!salaries || salaries.length === 0) {
//     toast.error("No salary records to export");
//     return;
//   }

//   const excelData = salaries.map((item, index) => ({
//     "SN": (currentPage - 1) * rowsPerPage + index + 1,
//     "Employee Name": item.employee?.fullName,
//     "Employee ID": item.employee?.userId,
//     "Working Days": item.workingDays,
//     "Net Salary": item.netSalary,
//     "Gross Salary": item.grossSalary,
//     "Salary Month": item.salaryMonth,
//     "Payable Days": item.payableDays,
//     "Paid Date": item.paidDate
//       ? new Date(item.paidDate).toLocaleDateString("en-GB")
//       : "-",
//     "Status": item.status,
//   }));

//   const worksheet = XLSX.utils.json_to_sheet(excelData);
//   const workbook = XLSX.utils.book_new();
//   XLSX.utils.book_append_sheet(workbook, worksheet, "Salary Disbursement");

//   const excelBuffer = XLSX.write(workbook, {
//     bookType: "xlsx",
//     type: "array",
//   });

//   const file = new Blob([excelBuffer], {
//     type:
//       "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
//   });

//   saveAs(file, `Salary_Disbursement_${Date.now()}.xlsx`);
// };


// const downloadPDF = () => {
//   if (!salaries || salaries.length === 0) {
//     toast.error("No salary records to export");
//     return;
//   }

//   const doc = new jsPDF("l", "mm", "a4");

//   doc.text("Salary Disbursement Report", 14, 15);

//   const tableHead = [[
//     "SN",
//     "Employee Name",
//     "Employee ID",
//     "Working Days",
//     "Net Salary",
//     "Gross Salary",
//     "Salary Month",
//     "Payable Days",
//     "Paid Date",
//     "Status",
//   ]];

//   const tableBody = salaries.map((item, index) => [
//     (currentPage - 1) * rowsPerPage + index + 1,
//     item.employee?.fullName,
//     item.employee?.userId,
//     item.workingDays,
//     item.netSalary,
//     item.grossSalary,
//     item.salaryMonth,
//     item.payableDays,
//     item.paidDate
//       ? new Date(item.paidDate).toLocaleDateString("en-GB")
//       : "-",
//     item.status,
//   ]);

//   autoTable(doc, {
//     head: tableHead,
//     body: tableBody,
//     startY: 20,
//     styles: { fontSize: 9 },
//     theme: "grid",
//   });

//   doc.save(`Salary_Disbursement_${Date.now()}.pdf`);
// };



//   return (
//     <div className="attendance-summary-container">
//       <h1 className="attendance-summary-heading">Salary Disbursment</h1>

//       {/* ================= FILTER ================= */}
//       <section className="attendance-summary-top">
//         <form className="attendance-summary-form" onSubmit={handleSubmit}>
//           <div className="attendance-summary-form-section">
//             <div className="attendance-summary-form-input-fields">
//               <label>Select Branch</label>
//               <select
//                 value={selectedBranch?.id || ""}
//                 onChange={(e) =>
//                   setSelectedBranch(
//                     branchs.find((b) => b.id === Number(e.target.value))
//                   )
//                 }
//               >
//                 <option value="">Select Branch</option>
//                 {branchs.map((b) => (
//                   <option key={b.id} value={b.id}>
//                     {b.name}
//                   </option>
//                 ))}
//               </select>
//             </div>

//             <div className="attendance-summary-form-input-fields">
//               <label>Select Employee</label>
//               <select
//                 disabled={!selectedBranch}
//                 value={selectedEmployee?.id || ""}
//                 onChange={(e) =>
//                   setSelectedEmployee(
//                     employees.find(
//                       (emp) => emp.id === Number(e.target.value)
//                     )
//                   )
//                 }
//               >
//                 <option value="">Select Employee</option>
//                 {employees.map((emp) => (
//                   <option key={emp.id} value={emp.id}>
//                     {emp.fullName} - {emp.id}
//                   </option>
//                 ))}
//               </select>
//             </div>

//             <div className="attendance-summary-form-input-fields">
//               <label>Month</label>
//               <input
//                 type="month"
//                 value={month}
//                 onChange={(e) => setMonth(e.target.value)}
//               />
//             </div>
//           </div>

//           <div className="attendance-summary-form-submit-btn">
//             <button type="submit">
//               {loading ? "Loading..." : "Get Records"}
//             </button>
//           </div>
//         </form>
//       </section>

//       {/* ================= REPORT ================= */}
//       <div className="attendance-summary-report-container">
//         <div className="attendance-summary-report-filter-div">
//           <div className="attendance-summary-filter">
//             <label>Show </label>
//             <select value={rowsPerPage} onChange={handleItemsPerPageChange}>
//               {ITEMS_PER_PAGE_OPTIONS.map((num) => (
//                 <option key={num} value={num}>
//                   {num}
//                 </option>
//               ))}
//             </select>
//             <span> entries</span>
//           </div>

//           <div className="attendance-summary-total-records">
//             Total Records: {totalRecords}
//           </div>
//         </div>

//         <div className="attendance-summary-report-table-container">
//           {error && <p className="error-text">{error}</p>}


//           <div style={{ display: "flex", gap: "12px", marginBottom: "15px" }}>
//   <button
//     onClick={downloadExcel}
//     className="attendance-summary-download-btn"
//   >
//     ⬇️  Excel
//   </button>

//   <button
//     onClick={downloadPDF}
//     className="attendance-summary-download-btn"
//   >
//     ⬇️  PDF
//   </button>
// </div>


//           <table className="attendance-summary-report-table">
//             <thead>
//               <tr>
//                 <th>SN</th>
//                 <th>Employee Name</th>
//                 <th>Employee Id</th>
//                 <th>Working Days</th>
//                 <th>Net Salary</th>
//                 <th>Gross Salary</th>
//                 <th>Salary Month</th>
//                 <th>Payable Days</th>
//                 <th>Paid Date</th>
//                 <th>Action</th>
//               </tr>
//             </thead>

//             <tbody>
//               {salaries.length > 0 ? (
//                 salaries.map((item, index) => (
//                   <tr key={item.id}>
//                     <td>{(currentPage - 1) * rowsPerPage + index + 1}</td>
//                     <td>{item.employee?.fullName}</td>
//                     <td>{item.employee?.userId}</td>
//                     <td>{item.workingDays}</td>
//                     <td>{item.netSalary}</td>
//                     <td>{item.grossSalary}</td>
//                     <td>{item.salaryMonth}</td>
//                     <td>{item.payableDays}</td>
//                     <td>{new Date(item.paidDate).toLocaleDateString("en-GB") || "-"}</td>
//                     <td>
//                       {item.status === "CALCULATED" ? (
//                         <div className="attendance-calculate-salary-btn">
//                          <button
//                           onClick={() =>{
//                             // DisburseSalary(item.id, item.month, item.year)
//                             setSelectedSalaryId(item.id);
//                             setModalOpen(true);
//                            } }
//                         >
//                           Disburse
//                         </button>
//                         </div>
//                       ) : (
//                         <span className="attendance-disbursed-badge">
//                           Disbursed
//                         </span>
//                       )}
//                     </td>
//                   </tr>
//                 ))
//               ) : (
//                 <tr>
//                   <td colSpan="10" style={{ textAlign: "center" }}>
//                     {loading ? "Loading..." : "No records found"}
//                   </td>
//                 </tr>
//               )}
//             </tbody>
//           </table>
//         </div>
//       </div>

//       {/* ================= PAGINATION ================= */}
//       {totalPages > 1 && (
//         <div className="attendance-summary-pagination-div">
//           <button
//             disabled={currentPage === 1}
//             onClick={() => setCurrentPage((p) => p - 1)}
//           >
//             ⬅ Prev
//           </button>

//           <span>
//             Page {currentPage} of {totalPages}
//           </span>

//           <button
//             disabled={currentPage === totalPages}
//             onClick={() => setCurrentPage((p) => p + 1)}
//           >
//             Next ➡
//           </button>
//         </div>
//       )}

//       {/* Modal */}
//         {modalOpen && (
//           <div className="dialog-overlay">
//             <div className="dialog-box">
//               <h2 className="dialog-box-heading">
//                 {"Disburse Salary"}
//               </h2>

//               <form className="dialog-box-form-section" onSubmit={DisburseSalary}>
//                 <div className="dialog-box-input-group">
//                   <label>Payment Mode</label>
//                   <input
//                     type="text"
//                     name="paymentMode"
//                     value={formData.paymentMode}
//                     onChange={handleChange}
//                   />
//                 </div>

//                 <div className="dialog-box-input-group">
//                   <label>Transaction Ref.</label>
//                    <input
//                     type="text"
//                     name="transactionRef"
//                     value={formData.transactionRef}
//                     onChange={handleChange}
//                   />
//                 </div>

//                 <div className="dialog-btns">
//                   <button type="submit">
//                     {"Disburse"}
//                   </button>

//                   <button type="button" onClick={() => setModalOpen(false)}>
//                     Cancel
//                   </button>
//                 </div>
//               </form>
//             </div>
//           </div>
//         )}
//     </div>
//   );
// };

// export default SalaryDisbursement;



























// import React, { useEffect, useState, useCallback } from "react";
// import "../assets/SalaryDisbursement.css";
// import axios from "axios";
// import { toast, ToastContainer } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";

// import * as XLSX from "xlsx";
// import { saveAs } from "file-saver";
// import jsPDF from "jspdf";
// import autoTable from "jspdf-autotable";

// const ITEMS_PER_PAGE_OPTIONS = [10, 25, 50, 100];
// const API_URL = "https://narrowitsolution.in/api";

// const SalaryDisbursement = () => {
//   const [salaries, setSalaries] = useState([]);
//   const [branchs, setBranchs] = useState([]);
//   const [employees, setEmployees] = useState([]);

//   const [month, setMonth] = useState("");
//   const [appliedMonth, setAppliedMonth] = useState("");

//   const [selectedBranch, setSelectedBranch] = useState(null);
//   const [selectedEmployee, setSelectedEmployee] = useState(null);

//   const [currentPage, setCurrentPage] = useState(1);
//   const [rowsPerPage, setRowsPerPage] = useState(10);
//   const [totalPages, setTotalPages] = useState(1);
//   const [totalRecords, setTotalRecords] = useState(0);
//   const [modalOpen, setModalOpen] = useState(false);
//   const [selectedSalaryId, setSelectedSalaryId] = useState();

//   const [loading, setLoading] = useState(false);
//   const [slipLoading, setSlipLoading] = useState(null); // Track specific slip download
//   const [error, setError] = useState("");

//   const [formData, setFormData] = useState({
//     paymentMode: "",
//     transactionRef: "",
//   });

//   const handleChange = (e) => {
//     setFormData({ ...formData, [e.target.name]: e.target.value });
//   };

//   /* ================= FETCH BRANCH ================= */
//   useEffect(() => {
//     const fetchBranch = async () => {
//       try {
//         const res = await axios.get(`${API_URL}/get-branch`, {
//           params: {
//             SuperAdminId: localStorage.getItem("adminuserId"),
//             limit: "all",
//           },
//         });
//         setBranchs(res?.data?.branches || []);
//       } catch (err) {
//         console.error(err);
//       }
//     };
//     fetchBranch();
//   }, []);

//   /* ================= FETCH EMPLOYEES ================= */
//   useEffect(() => {
//     if (!selectedBranch) {
//       setEmployees([]);
//       setSelectedEmployee(null);
//       return;
//     }

//     const fetchEmployees = async () => {
//       try {
//         const res = await axios.get(`${API_URL}/get-employ`, {
//           params: {
//             superAdminId: localStorage.getItem("adminuserId"),
//             branchId: selectedBranch.id,
//             limit: 50,
//           },
//         });
//         setEmployees(res?.data?.data || []);
//       } catch (err) {
//         console.error(err);
//       }
//     };

//     fetchEmployees();
//   }, [selectedBranch]);

//   /* ================= FETCH SALARY RECORDS ================= */
//   const fetchSalary = useCallback(
//     async (isFiltered = false) => {
//       try {
//         setLoading(true);
//         setError("");
//         const token = localStorage.getItem("authToken");
//         const superAdminId = localStorage.getItem("adminuserId");

//         const res = await axios.get(
//           `${API_URL}/get-all-salery-disbursed/get-all`,
//           {
//             params: {
//               superAdminId,
//               currentPage,
//               pageSize: rowsPerPage,
//               employee_id: isFiltered ? selectedEmployee?.id : undefined,
//               month: isFiltered ? appliedMonth : undefined,
//             },
//             headers: { Authorization: `Bearer ${token}` },
//           }
//         );

//         setSalaries(res?.data?.data || []);
//         setTotalPages(res?.data?.totalPages || 1);
//         setTotalRecords(res?.data?.totalRecords || 0);
//       } catch (err) {
//         setError(err?.response?.data?.message || "Failed to fetch salaries");
//       } finally {
//         setLoading(false);
//       }
//     },
//     [currentPage, rowsPerPage, selectedEmployee, appliedMonth]
//   );

//   useEffect(() => {
//     fetchSalary(false);
//   }, [fetchSalary]);

//   /* ================= DISBURSE SALARY ================= */
//   const DisburseSalary = async (e) => {
//     e.preventDefault();
//     try {
//       const response = await axios.post(
//         `${API_URL}/disubursed-salary/employe`,
//         {
//           salaryId: selectedSalaryId,
//           paymentMode: formData.paymentMode,
//           transactionRef: formData.transactionRef,
//         }
//       );

//       toast.success("Salary Disbursed successfully!");
//       setModalOpen(false);
//       fetchSalary();
//     } catch (error) {
//       const msg = error?.response?.data?.message || "Something went wrong";
//       toast.error(msg);
//     }
//   };

//   /* ================= DOWNLOAD SALARY SLIP ================= */
//   const downloadSalarySlip = async (employeeId, salaryMonth, index) => {
//     try {
//       setSlipLoading(index);
//       const superAdminId = localStorage.getItem("adminuserId");
//       const res = await axios.get(`${API_URL}/get-salary-slip/employe`, {
//         params: { employeeId, salaryMonth, superAdminId },
//       });

//       if (res.data.success) {
//         generatePDFSlip(res.data.salarySlip);
//         toast.success("Salary slip generated!");
//       }
//     } catch (err) {
//       toast.error("Error fetching salary slip data");
//     } finally {
//       setSlipLoading(null);
//     }
//   };

//   /* ================= GENERATE PDF LOGIC ================= */
//   const generatePDFSlip = (data) => {
//     const doc = new jsPDF();
//     const { employee, period, attendance, earnings, deductions, netSalary, payment } = data;

//     // Title
//     doc.setFontSize(18);
//     doc.text("Salary Slip", 105, 20, { align: "center" });
//     doc.setFontSize(12);
//     doc.text(` - ${employee.branchName}`, 105, 28, { align: "center" });

//     // Details Header
//     doc.setFontSize(10);
//     doc.rect(14, 35, 182, 30);
//     doc.text(`Employee Name: ${employee.fullName}`, 20, 42);
//     doc.text(`Employee ID: ${employee.userId}`, 20, 48);
//     doc.text(`Email: ${employee.email}`, 20, 54);
//     doc.text(`Month: ${period.salaryMonth}`, 140, 42);
//     doc.text(`Mobile: ${employee.mobileNumber}`, 140, 48);

//     // Attendance Table
//     autoTable(doc, {
//       startY: 70,
//       head: [["Attendance Detail", "Count"]],
//       body: [
//         ["Total Days", attendance.totalDays],
//         ["Paid Days", attendance.paidDays],
//         ["Unpaid Days", attendance.unpaidDays],
//       ],
//       theme: "grid",
//     });

//     // Earnings & Deductions
//     autoTable(doc, {
//       startY: doc.lastAutoTable.finalY + 10,
//       head: [["Earnings", "Amount", "Deductions", "Amount"]],
//       body: [
//         ["Gross Salary", earnings.grossSalary, "Total Deductions", deductions.totalDeductions],
//       ],
//       theme: "striped",
//     });

//     // Net Amount
//     const finalY = doc.lastAutoTable.finalY + 15;
//     doc.setFontSize(12);
//     doc.setFont(undefined, "bold");
//     doc.text(`NET SALARY: ${netSalary.toFixed(2)}`, 140, finalY);

//     // Footer
//     doc.setFontSize(9);
//     doc.setFont(undefined, "normal");
//     doc.text(`Payment Status: ${payment.status}`, 14, finalY + 10);
//     doc.text(`Transaction Ref: ${payment.transactionRef || "N/A"}`, 14, finalY + 16);
//     doc.text(`Generated At: ${new Date(data.generatedAt).toLocaleString()}`, 14, finalY + 22);

//     doc.save(`Slip_${employee.fullName}_${period.salaryMonth}.pdf`);
//   };

//   /* ================= UI RENDER ================= */
//   return (
//     <div className="attendance-summary-container">
//       <h1 className="attendance-summary-heading">Salary Disbursement</h1>

//       <section className="attendance-summary-top">
//         <form className="attendance-summary-form" onSubmit={(e) => { e.preventDefault(); setAppliedMonth(month); fetchSalary(true); }}>
//           <div className="attendance-summary-form-section">
//             <div className="attendance-summary-form-input-fields">
//               <label>Select Branch</label>
//               <select onChange={(e) => setSelectedBranch(branchs.find(b => b.id === Number(e.target.value)))}>
//                 <option value="">Select Branch</option>
//                 {branchs.map(b => <option key={b.id} value={b.id}>{b.name}</option>)}
//               </select>
//             </div>

//             <div className="attendance-summary-form-input-fields">
//               <label>Select Employee</label>
//               <select disabled={!selectedBranch} onChange={(e) => setSelectedEmployee(employees.find(emp => emp.id === Number(e.target.value)))}>
//                 <option value="">Select Employee</option>
//                 {employees.map(emp => <option key={emp.id} value={emp.id}>{emp.fullName}</option>)}
//               </select>
//             </div>

//             <div className="attendance-summary-form-input-fields">
//               <label>Month</label>
//               <input type="month" value={month} onChange={(e) => setMonth(e.target.value)} />
//             </div>
//           </div>
//           <button type="submit" className="attendance-summary-form-submit-btn">Get Records</button>
//         </form>
//       </section>

//       <div className="attendance-summary-report-container">
//         <div className="attendance-summary-report-table-container">
//           <table className="attendance-summary-report-table">
//             <thead>
//               <tr>
//                 <th>SN</th>
//                 <th>Employee Name</th>
//                 <th>Employee Id</th>
//                 <th>Working Days</th>
//                 <th>Net Salary</th>
//                 <th>Gross Salary</th>
//                 <th>Salary Month</th>
//                 <th>Paid Date</th>
//                 <th>Action</th>
//                 <th>Salary Slip</th>
//               </tr>
//             </thead>
//             <tbody>
//               {salaries.map((item, index) => (
//                 <tr key={item.id}>
//                   <td>{(currentPage - 1) * rowsPerPage + index + 1}</td>
//                   <td>{item.employee?.fullName}</td>
//                   <td>{item.employee?.userId}</td>
//                   <td>{item.workingDays}</td>
//                   <td>{item.netSalary}</td>
//                   <td>{item.grossSalary}</td>
//                   <td>{item.salaryMonth}</td>
//                   <td>{item.paidDate ? new Date(item.paidDate).toLocaleDateString("en-GB") : "-"}</td>
//                   <td>
//                     {item.status === "CALCULATED" ? (
//                       <button className="disburse-action-btn" onClick={() => { setSelectedSalaryId(item.id); setModalOpen(true); }}>Disburse</button>
//                     ) : (
//                       <span className="disbursed-status-badge">Disbursed</span>
//                     )}
//                   </td>
//                   <td>
//                     {item.status !== "CALCULATED" ? (
//                       <button 
//                         className="download-slip-btn" 
//                         onClick={() => downloadSalarySlip(item.employee.id, item.salaryMonth, index)}
//                         disabled={slipLoading === index}
//                       >
//                         {slipLoading === index ? "..." : "⬇ PDF"}
//                       </button>
//                     ) : (
//                       <span className="wait-text">Pending</span>
//                     )}
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>
//       </div>

//       {/* MODAL */}
//       {modalOpen && (
//         <div className="dialog-overlay">
//           <div className="dialog-box">
//             <h2 className="dialog-box-heading">Disburse Salary</h2>
//             <form className="dialog-box-form-section" onSubmit={DisburseSalary}>
//               <div className="dialog-box-input-group">
//                 <label>Payment Mode</label>
//                 <input type="text" name="paymentMode" required value={formData.paymentMode} onChange={handleChange} />
//               </div>
//               <div className="dialog-box-input-group">
//                 <label>Transaction Ref.</label>
//                 <input type="text" name="transactionRef" required value={formData.transactionRef} onChange={handleChange} />
//               </div>
//               <div className="dialog-btns">
//                 <button type="submit">Disburse</button>
//                 <button type="button" onClick={() => setModalOpen(false)}>Cancel</button>
//               </div>
//             </form>
//           </div>
//         </div>
//       )}
//       <ToastContainer position="top-right" autoClose={3000} theme="colored" />
//     </div>
//   );
// };

// export default SalaryDisbursement;



import React, { useEffect, useState, useCallback } from "react";
import "../assets/SalaryDisbursement.css";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

const ITEMS_PER_PAGE_OPTIONS = [10, 25, 50, 100];
const API_URL = "https://narrowitsolution.in/api";

const SalaryDisbursement = () => {
  // Existing States
  const [salaries, setSalaries] = useState([]);
  const [branchs, setBranchs] = useState([]);
  const [employees, setEmployees] = useState([]);
  const [month, setMonth] = useState("");
  const [appliedMonth, setAppliedMonth] = useState("");
  const [selectedBranch, setSelectedBranch] = useState(null);
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedSalaryId, setSelectedSalaryId] = useState();
  const [loading, setLoading] = useState(false);
  const [slipLoading, setSlipLoading] = useState(null);
  const [error, setError] = useState("");
  
  // ✅ New Company State
  const [company, setCompany] = useState(null);
  const superAdminId = localStorage.getItem("adminuserId");

  const [formData, setFormData] = useState({
    paymentMode: "",
    transactionRef: "",
  });

  /* ================= FETCH COMPANY DETAILS ================= */
  useEffect(() => {
    const fetchCompany = async () => {
      try {
        const res = await fetch(
          `${API_URL}/get-company?superAdminId=${superAdminId}`
        );
        const data = await res.json();
        if (res.ok && data) {
          if (data.logo) {
            data.logoUrl = `https://narrowitsolution.in/${data.logo.replace(/^images\//, "")}`;
          }
          setCompany(data);
        }
      } catch (err) {
        console.error("Error fetching company details:", err);
      }
    };

    if (superAdminId) fetchCompany();
  }, [superAdminId]);

  /* ================= FETCH BRANCH & EMPLOYEES (Existing) ================= */
  useEffect(() => {
    const fetchBranch = async () => {
      try {
        const res = await axios.get(`${API_URL}/get-branch`, {
          params: { SuperAdminId: superAdminId, limit: "all" },
        });
        setBranchs(res?.data?.branches || []);
      } catch (err) { console.error(err); }
    };
    fetchBranch();
  }, [superAdminId]);

  useEffect(() => {
    if (!selectedBranch) { setEmployees([]); return; }
    const fetchEmployees = async () => {
      try {
        const res = await axios.get(`${API_URL}/get-employ`, {
          params: { superAdminId, branchId: selectedBranch.id, limit: 50 },
        });
        setEmployees(res?.data?.data || []);
      } catch (err) { console.error(err); }
    };
    fetchEmployees();
  }, [selectedBranch, superAdminId]);

  // fetchSalary, DisburseSalary, handleChange logic remains same...
  const handleChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value });

  const fetchSalary = useCallback(async (isFiltered = false) => {
    try {
      setLoading(true);
      const res = await axios.get(`${API_URL}/get-all-salery-disbursed/get-all`, {
        params: {
          superAdminId, currentPage, pageSize: rowsPerPage,
          employee_id: isFiltered ? selectedEmployee?.id : undefined,
          month: isFiltered ? appliedMonth : undefined,
        },
        headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
      });
      setSalaries(res?.data?.data || []);
      setTotalPages(res?.data?.totalPages || 1);
      setTotalRecords(res?.data?.totalRecords || 0);
    } catch (err) { setError("Failed to fetch salaries"); } finally { setLoading(false); }
  }, [currentPage, rowsPerPage, selectedEmployee, appliedMonth, superAdminId]);

  useEffect(() => { fetchSalary(false); }, [fetchSalary]);

  const DisburseSalary = async (e) => {
    e.preventDefault();
    try {
      await axios.post(`${API_URL}/disubursed-salary/employe`, {
        salaryId: selectedSalaryId,
        paymentMode: formData.paymentMode,
        transactionRef: formData.transactionRef,
      });
      toast.success("Salary Disbursed successfully!");
      setModalOpen(false);
      fetchSalary();
    } catch (error) { toast.error("Disbursement failed"); }
  };





  /* ================= DOWNLOAD SALARY SLIP ================= */
  const downloadSalarySlip = async (employeeId, salaryMonth, index) => {
    try {
      setSlipLoading(index);
      const res = await axios.get(`${API_URL}/new-salary-slip/employe`, {
        params: { employeeId, salaryMonth, superAdminId },
      });
      if (res.data.success) {
        await generatePDFSlip(res.data.salarySlip);
        toast.success("Salary slip generated!");
      }
    } catch (err) { toast.error("Error fetching salary slip"); } finally { setSlipLoading(null); }
  };



  // /* ================= GENERATE PDF LOGIC (Updated with Header) ================= */
  // const generatePDFSlip = async (data) => {
  //   const doc = new jsPDF("p", "mm", "a4");
  //   const { employee, period, attendance, earnings, deductions, netSalary, payment } = data;
  //   const margin = 14;
  //   let y = 15;
  //   const pageWidth = doc.internal.pageSize.getWidth();
  //   const centerX = pageWidth / 2;

  //   // Helper to load logo
  //   const loadLogo = async () => {
  //     if (!company?.logoUrl) return null;
  //     try {
  //       const res = await fetch(company.logoUrl);
  //       const blob = await res.blob();
  //       return await new Promise((resolve) => {
  //         const reader = new FileReader();
  //         reader.onload = (e) => resolve(e.target.result);
  //         reader.readAsDataURL(blob);
  //       });
  //     } catch (err) { return null; }
  //   };

  //   const logoImg = await loadLogo();

  //   // ---------- COMPANY HEADER ----------
  //   if (logoImg) {
  //     doc.addImage(logoImg, "PNG", margin, y, 25, 25);
  //   }

  //   doc.setFont("helvetica", "bold");
  //   doc.setFontSize(16);
  //   doc.text(company?.name || "Company Name", centerX, y + 8, { align: "center" });

  //   doc.setFont("helvetica", "normal");
  //   doc.setFontSize(9);
  //   if (company?.cin) doc.text(`CIN: ${company.cin}`, centerX, y + 14, { align: "center" });
  //   if (company?.address) doc.text(`${company.address}`, centerX, y + 19, { align: "center", maxWidth: 100 });
  //   doc.text(`Email: ${company?.email || "-"} | Ph: ${company?.contact || "-"}`, centerX, y + 26, { align: "center" });

  //   y += 32;
  //   doc.setDrawColor(200);
  //   doc.line(margin, y, pageWidth - margin, y);

  //   // Slip Title
  //   y += 10;
  //   doc.setFontSize(12);
  //   doc.setFont("helvetica", "bold");
  //   doc.text("PAY SLIP", centerX, y, { align: "center" });

  //   // ---------- EMPLOYEE DETAILS ----------
  //   y += 10;
  //   doc.setFontSize(10);
  //   doc.setFont("helvetica", "normal");
  //   doc.rect(margin, y, pageWidth - (margin * 2), 25);
    
  //   const leftCol = margin + 5;
  //   const rightCol = 110;
    
  //   doc.text(`Employee Name: ${employee.fullName}`, leftCol, y + 7);
  //   doc.text(`Employee ID: ${employee.userId}`, leftCol, y + 14);
  //   doc.text(`Branch: ${employee.branchName}`, leftCol, y + 21);

  //   doc.text(`Salary Period: ${period.salaryMonth}`, rightCol, y + 7);
  //   doc.text(`Mobile: ${employee.mobileNumber}`, rightCol, y + 14);
  //   doc.text(`Status: ${payment.status}`, rightCol, y + 21);

  //   y += 30;

  //   // Attendance Table
  //   autoTable(doc, {
  //     startY: y,
  //     head: [["Attendance Detail", "Value"]],
  //     body: [
  //       ["Total Days in Month", attendance.totalDays],
  //       ["Paid Days", attendance.paidDays],
  //       ["Unpaid Days", attendance.unpaidDays],
  //     ],
  //     theme: "grid",
  //     headStyles: { fillColor: [40, 40, 40] },
  //     margin: { left: margin, right: margin }
  //   });

  //   // Earnings Table
  //   autoTable(doc, {
  //     startY: doc.lastAutoTable.finalY + 5,
  //     head: [["Earnings", "Amount", "Deductions", "Amount"]],
  //     body: [
  //       ["Basic Gross Salary", earnings.grossSalary.toFixed(2), "Total Deductions", deductions.totalDeductions.toFixed(2)],
  //     ],
  //     theme: "grid",
  //     headStyles: { fillColor: [40, 40, 40] },
  //     margin: { left: margin, right: margin }
  //   });

  //   // Net Salary Section
  //   const finalY = doc.lastAutoTable.finalY + 10;
  //   doc.setFillColor(245, 245, 245);
  //   doc.rect(margin, finalY, pageWidth - (margin * 2), 12, "F");
  //   doc.setFont("helvetica", "bold");
  //   doc.text(`NET PAYABLE SALARY:`, margin + 5, finalY + 8);
  //   doc.text(`${netSalary.toFixed(2)}`, pageWidth - margin - 30, finalY + 8);

  //   // Footer Info
  //   doc.setFont("helvetica", "normal");
  //   doc.setFontSize(8);
  //   doc.text(`Payment Mode: ${payment.paymentMode || "N/A"}`, margin, finalY + 20);
  //   doc.text(`Ref No: ${payment.transactionRef || "N/A"}`, margin, finalY + 25);
  //   doc.text(`Paid Date: ${payment.paidDate ? new Date(payment.paidDate).toLocaleDateString() : "-"}`, margin, finalY + 30);
  //   doc.text(`*This is a computer generated document.`, centerX, finalY + 45, { align: "center" });

  //   doc.save(`SalarySlip_${employee.fullName}_${period.salaryMonth}.pdf`);
  // };


  /* ================= GENERATE PDF LOGIC ================= */
  const generatePDFSlip = async (data) => {
    const doc = new jsPDF("p", "mm", "a4");
    const { employee, period, attendance, earnings, deductions, netSalary, payment } = data;
    const margin = 14;
    let y = 15;
    const pageWidth = doc.internal.pageSize.getWidth();
    const centerX = pageWidth / 2;

    // Helper to load logo
    const loadLogo = async () => {
      if (!company?.logoUrl) return null;
      try {
        const res = await fetch(company.logoUrl);
        const blob = await res.blob();
        return await new Promise((resolve) => {
          const reader = new FileReader();
          reader.onload = (e) => resolve(e.target.result);
          reader.readAsDataURL(blob);
        });
      } catch (err) { return null; }
    };

    const logoImg = await loadLogo();

    // ---------- COMPANY HEADER ----------
    if (logoImg) {
      doc.addImage(logoImg, "PNG", margin, y, 20, 20);
    }

    doc.setFont("helvetica", "bold");
    doc.setFontSize(16);
    doc.text(company?.name || "PAYYUG SOLUTIONS", centerX, y + 8, { align: "center" });

    doc.setFont("helvetica", "normal");
    doc.setFontSize(9);
    doc.text(`${company?.address || "Company Address Line, City"}`, centerX, y + 14, { align: "center", maxWidth: 100 });
    doc.text(`Email: ${company?.email || "-"} | Ph: ${company?.contact || "-"}`, centerX, y + 20, { align: "center" });

    y += 28;
    doc.setDrawColor(200);
    doc.line(margin, y, pageWidth - margin, y);

    // Slip Title
    y += 10;
    doc.setFontSize(12);
    doc.setFont("helvetica", "bold");
    doc.text(`PAYSLIP - ${period.salaryMonth}`, centerX, y, { align: "center" });

    // ---------- EMPLOYEE & ATTENDANCE DETAILS ----------
    y += 10;
    doc.setFontSize(10);
    doc.setFont("helvetica", "bold");
    doc.text("Employee Details", margin, y);
    doc.text("Attendance Details", 130, y);
    
    y += 2;
    doc.setFont("helvetica", "normal");
    // Column 1: Employee info
    doc.text(`Name: ${employee.fullName}`, margin, y + 6);
    doc.text(`ID: ${employee.userId}`, margin, y + 12);
    doc.text(`Branch: ${employee.branchName}`, margin, y + 18);
    
    // Column 2: Attendance info (Mapping from your JSON)
    doc.text(`Working Days: ${attendance.workingDays}`, 130, y + 6);
    doc.text(`Present Days: ${attendance.presentDays}`, 130, y + 12);
    doc.text(`Paid Days: ${attendance.paidDays}`, 130, y + 18);

    y += 25;

    // ---------- EARNINGS & DEDUCTIONS TABLE ----------
    autoTable(doc, {
      startY: y,
      head: [['Earnings', 'Amount', 'Deductions', 'Amount']],
      body: [
        ['Basic Salary', earnings.basic.toFixed(2), 'P.F.', deductions.pf.toFixed(2)],
        ['HRA', earnings.hra.toFixed(2), 'Other', deductions.other.toFixed(2)],
        ['Commission', earnings.commission.toFixed(2), 'Leave Deduction', deductions.leave.toFixed(2)],
        ['Allowances', earnings.allowances.toFixed(2), 'Advance', deductions.advance.toFixed(2)],
        [{ content: 'Gross Earnings', styles: { fontStyle: 'bold' } }, 
         { content: earnings.grossSalary.toFixed(2), styles: { fontStyle: 'bold' } }, 
         { content: 'Total Deductions', styles: { fontStyle: 'bold' } }, 
         { content: deductions.totalDeductions.toFixed(2), styles: { fontStyle: 'bold' } }
        ],
      ],
      theme: 'grid',
      headStyles: { fillColor: [60, 60, 60], textColor: [255, 255, 255] },
      styles: { fontSize: 9, cellPadding: 3 },
    });

    // ---------- NET SALARY SECTION ----------
    const finalY = doc.lastAutoTable.finalY + 5;
    doc.setFillColor(240, 240, 240);
    doc.rect(margin, finalY, pageWidth - (margin * 2), 10, "F");
    doc.setFont("helvetica", "bold");
    doc.setFontSize(11);
    doc.text(`NET PAYABLE`, margin + 5, finalY + 7);

        doc.text(netSalary.toLocaleString('en-IN'), margin + 10, finalY + 14);


    // ---------- PAYMENT INFO ----------
    doc.setFont("helvetica", "normal");
    doc.setFontSize(9);
    y = finalY + 20;
    doc.text(`Payment Method: ${payment.paymentMode.toUpperCase()}`, margin, y);
    doc.text(`Transaction Ref: ${payment.transactionRef}`, margin, y + 6);
    doc.text(`Paid Date: ${new Date(payment.paidDate).toLocaleDateString()}`, margin, y + 12);

    // Footer
    doc.setFontSize(8);
    doc.setTextColor(100);
    doc.text("This is a computer-generated salary slip and does not require a physical signature.", centerX, 280, { align: "center" });

    doc.save(`SalarySlip_${employee.fullName.replace(" ", "_")}_${period.salaryMonth}.pdf`);
  };









  return (
    <div className="attendance-summary-container">
      {/* ... Rest of your UI code remains identical ... */}
      <h1 className="attendance-summary-heading">Salary Disbursement</h1>
      
      {/* Search Filter Form */}
      <section className="attendance-summary-top">
        <form className="attendance-summary-form" onSubmit={(e) => { e.preventDefault(); setAppliedMonth(month); fetchSalary(true); }}>
          <div className="attendance-summary-form-section">
            <div className="attendance-summary-form-input-fields">
              <label>Select Branch</label>
              <select onChange={(e) => setSelectedBranch(branchs.find(b => b.id === Number(e.target.value)))}>
                <option value="">Select Branch</option>
                {branchs.map(b => <option key={b.id} value={b.id}>{b.name}</option>)}
              </select>
            </div>
            <div className="attendance-summary-form-input-fields">
              <label>Select Employee</label>
              <select disabled={!selectedBranch} onChange={(e) => setSelectedEmployee(employees.find(emp => emp.id === Number(e.target.value)))}>
                <option value="">Select Employee</option>
                {employees.map(emp => <option key={emp.id} value={emp.id}>{emp.fullName}</option>)}
              </select>
            </div>
            <div className="attendance-summary-form-input-fields">
              <label>Month</label>
              <input type="month" value={month} onChange={(e) => setMonth(e.target.value)} />
            </div>
          </div>
          <button type="submit" className="attendance-summary-form-submit-btn">Get Records</button>
        </form>
      </section>

      <div className="attendance-summary-report-container">
         {/* Download Buttons */}
         <div style={{ display: "flex", gap: "12px", marginBottom: "15px" }}>
            <button onClick={() => toast.info("Excel download logic here")} className="attendance-summary-download-btn">⬇️ Excel</button>
            <button onClick={() => toast.info("PDF download logic here")} className="attendance-summary-download-btn">⬇️ PDF</button>
         </div>

        <div className="attendance-summary-report-table-container">
          <table className="attendance-summary-report-table">
            <thead>
              <tr>
                <th>SN</th>
                <th>Employee Name</th>
                <th>Employee Id</th>
                <th>Working Days</th>
                <th>Net Salary</th>
                <th>Gross Salary</th>
                <th>Salary Month</th>
                <th>Paid Date</th>
                <th>Action</th>
                <th>Salary Slip</th>
              </tr>
            </thead>
            <tbody>
              {salaries.map((item, index) => (
                <tr key={item.id}>
                  <td>{(currentPage - 1) * rowsPerPage + index + 1}</td>
                  <td>{item.employee?.fullName}</td>
                  <td>{item.employee?.userId}</td>
                  <td>{item.workingDays}</td>
                  <td>{item.netSalary}</td>
                  <td>{item.grossSalary}</td>
                  <td>{item.salaryMonth}</td>
                  <td>{item.paidDate ? new Date(item.paidDate).toLocaleDateString("en-GB") : "-"}</td>
                  <td>
                    {item.status === "CALCULATED" ? (
                      <button className="disburse-action-btn" onClick={() => { setSelectedSalaryId(item.id); setModalOpen(true); }}>Disburse</button>
                    ) : (
                      <span className="disbursed-status-badge">Disbursed</span>
                    )}
                  </td>
                  <td>
                    {item.status !== "CALCULATED" ? (
                      <button 
                        className="download-slip-btn" 
                        onClick={() => downloadSalarySlip(item.employee.id, item.salaryMonth, index)}
                        disabled={slipLoading === index}
                      >
                        {slipLoading === index ? "..." : "⬇ PDF"}
                      </button>
                    ) : (
                      <span className="wait-text">Pending</span>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* Disbursement Modal */}
      {modalOpen && (
        <div className="dialog-overlay">
          <div className="dialog-box">
            <h2 className="dialog-box-heading">Disburse Salary</h2>
            <form className="dialog-box-form-section" onSubmit={DisburseSalary}>
              <div className="dialog-box-input-group">
                <label>Payment Mode</label>
                <input type="text" name="paymentMode" required value={formData.paymentMode} onChange={handleChange} />
              </div>
              <div className="dialog-box-input-group">
                <label>Transaction Ref.</label>
                <input type="text" name="transactionRef" required value={formData.transactionRef} onChange={handleChange} />
              </div>
              <div className="dialog-btns">
                <button type="submit">Disburse</button>
                <button type="button" onClick={() => setModalOpen(false)}>Cancel</button>
              </div>
            </form>
          </div>
        </div>
      )}
      <ToastContainer position="top-right" autoClose={3000} theme="colored" />
    </div>
  );
};

export default SalaryDisbursement;